<template>
  <v-select
    v-model="selected"
    :items="items"
    prepend-icon="mdi-list-status"
    item-text="text"
    item-value="value"
    label="Status"
    filled
    hide-details
    solo-inverted
    multiple
    dense
    return-object
    item-color="white"
  >
    <template v-slot:item="{ item, attrs, on }">
      <v-list-item v-on="on" v-bind="attrs" #default="{ active }">
        <v-list-item-action
          :style="
            item.value === 'all' && {
              zIndex: -99,
            }
          "
        >
          <v-checkbox :ripple="false" :input-value="active"></v-checkbox>
        </v-list-item-action>

        <v-list-item-content>
          <v-list-item-title>
            <v-row no-gutters align="center">
              {{ item.text }}
            </v-row>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>

    <template v-slot:selection="{ item, index }">
      <div>
        <v-chip v-if="index === 0">
          <span>{{ item.text }}</span>
        </v-chip>
        <span
          v-if="index === 1 && !allSelected"
          class="grey--text text-caption"
        >
          (+{{ selected.length - 1 }} {{ $t("newCasino.others") }})
        </span>
      </div>
    </template>
  </v-select>
</template>
<script>
export default {
  data: () => ({
    selected: [],
  }),

  watch: {
    selected(newSelected, oldSelected) {
      // seleciona todos
      if (this.findAll(newSelected) && !this.findAll(oldSelected)) {
        this.selected = this.items;
      } else if (
        this.findAll(newSelected) &&
        this.items.length !== this.selected.length
      ) {
        this.selected = this.selected.filter((obj) => obj.value !== "all");
      } // remover "todos" ao remover um outro status enquanto há "todos" marcados && limpar selected ao clicar em "todos" com todos status marcados
      else if (!this.findAll(newSelected) && this.findAll(oldSelected)) {
        if (this.selected.length + 1 === this.items.length) {
          this.selected = [];
        } else {
          this.selected = this.selected.filter((obj) => obj.value !== "all");
        }
      } else if (
        !this.findAll(newSelected) &&
        this.selected.length + 1 === this.items.length
      ) {
        this.selected = this.items;
      }

      this.$store.commit("setCasinoBetsStatus", this.selected);
    },
  },

  computed: {
    allSelected() {
      return this.findAll(this.selected);
    },
    items() {
      const isExemptPlayer = this.$store.state.logged.data.isento_cassino;

      return [
        { text: this.$t("all"), value: "all" },
        {
          text: this.$t("casinoBetting.bet"),
          value: isExemptPlayer ? 114 : 101,
        },
        {
          text: this.$t("casinoBetting.prize"),
          value: isExemptPlayer ? 115 : 102,
        },
        {
          text: this.$t("casinoBetting.betRefund"),
          value: isExemptPlayer ? 116 : 108,
        },
        {
          text: this.$t("casinoBetting.prizeRefund"),
          value: isExemptPlayer ? 117 : 109,
        },
        {
          text: this.$t("casinoBetting.freespinPrize"),
          value: 113,
        },
      ];
    },
  },

  methods: {
    findAll(arr) {
      return arr.find((obj) => obj.value === "all");
    },
  },
};
</script>
<style>
/*
 .theme--dark.v-list-item--active::before,
.theme--dark.v-list-item--highlighted::before {
  opacity: 0 !important; 
}
*/
</style>
